import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import axios from "axios";

function SendMessage(props) {
  const [text, setText] = useState("");
  const changeText = (e) => {
    setText(e.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sessionStorage.setItem("message", "true");
    axios
      .post("/sendMessage", {
        patientId: props.uid,
        senderId: localStorage.getItem("user"),
        body: text,
      })
      .then(function (response) {
        setText("");
        window.location.reload();
      })
      .catch(function (error) {
        console.log(error);
      });

  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        id="Text"
        label="Text"
        type="text"
        value={text}
        onChange={changeText}
        fullWidth
      />
      <div className="loginSignUpButton">
        <Button type="submit" variant="contained" color="secondary">
          Send message
        </Button>
      </div>
    </form>
  );
}

export default SendMessage;
